import React from "react";
import PropTypes from "prop-types";
import { useCuvette } from "./Cuvette.utils";
import { CuvetteTooltip } from "./CuvetteTooltip";
import className from "./style.module.scss";

/**
 * Cuvette:
 *  - Standard Lab Cuvette Used to store solutions
 */
export function Cuvette(props) {
  const { drawCuvette } = useCuvette();

  const [showTooltip, setShowtTooltip] = React.useState(false);

  const toggleShowTooltip = (value) => () => setShowtTooltip(value);

  return (
    <div
      onMouseEnter={toggleShowTooltip(true)}
      onMouseLeave={toggleShowTooltip(false)}
      className={`${className.cuvette} ${props.className}`}
    >
      <CuvetteTooltip
        lidId={!props.hideControls ? props.lidId : -1}
        solution={!props.hideControls ? props.solution : null}
        showControls={showTooltip}
        onRemoveItem={props.onRemoveItem}
        buttonList={props.buttonList}
      />
      <div className={className.image}>{drawCuvette(props)}</div>
    </div>
  );
}

Cuvette.propTypes = {
  /**
   * Color value for the solution [ Empty means no solution]
   */
  solution: PropTypes.string,
  /**
   * UniqueId for the lid placed on cuvette
   */
  lidId: PropTypes.number,
  /**
   * Label to be displayed on tooltip
   */
  tooltipLabel: PropTypes.string,
  /**
   * Invoked when an item dropped in/over cuvette is removed
   */
  onRemoveItem: PropTypes.func,
};

Cuvette.defaultProps = {
  className: "cuvette",
  lidId: undefined,
  solution: "",
  tooltipLabel: "cuvette",
};
